exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-form[data-v-196aa94e]{background-color:#fff}.icon-style[data-v-196aa94e]{font-size:3rem!important}.color-text-default[data-v-196aa94e]{color:#707070}", ""]);

// exports
